import { formatUserDate } from 'owa-datetime';
import DateRange from 'owa-range-datepicker/lib/store/schema/DateRange';

export function getTextLabelForDateRange(dateRange: DateRange) {
    // TODO: VSO# 40353: Locallize the string with '-' as it might not be same across all languages
    return formatUserDate(dateRange.startDate) + ' - ' + formatUserDate(dateRange.endDate);
}
